import React from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';

interface CardPreviewProps {
  cardImage: string | null;
  onDownload: () => void;
  isGenerating: boolean;
}

const CardPreview: React.FC<CardPreviewProps> = ({ cardImage, onDownload, isGenerating }) => {
  const handleDownload = () => {
    if (cardImage) {
      // Create a link element and trigger download
      const link = document.createElement('a');
      link.href = cardImage;
      link.download = `social-card-${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      onDownload();
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-gray-900">Card Preview</h3>
      
      <div className="relative bg-gray-100 rounded-lg overflow-hidden aspect-[1200/630]">
        {cardImage ? (
          <>
            <img
              src={cardImage}
              alt="Social Card Preview"
              className="w-full h-full object-contain"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
          </>
        ) : (
          <div className="flex items-center justify-center h-full">
            {isGenerating ? (
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
                <p className="text-gray-500">Generating your card...</p>
              </div>
            ) : (
              <p className="text-gray-400">Your card preview will appear here</p>
            )}
          </div>
        )}
      </div>

      {cardImage && (
        <div className="space-y-3">
          <button
            onClick={handleDownload}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-medium transition-colors"
          >
            <ArrowDownTrayIcon className="h-5 w-5" />
            Download Card
          </button>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800">
              <strong>Tips for sharing:</strong>
            </p>
            <ul className="mt-2 text-sm text-blue-700 space-y-1">
              <li>• Download the image and upload to LinkedIn as a post</li>
              <li>• Add relevant hashtags like #Networking #TechEvent</li>
              <li>• Tag @star.london to increase visibility</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardPreview;